<div class="rs-dialog">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="title" mat-dialog-title>
      Add Action
      <span class="right-buttons">
        <button type="button" app-mat-icon-button (click)="onCancel()" matTooltip="Cancel" tabindex="-1">
          <span class="ri-cancel icon-button grey-icon"></span>
        </button>
      </span>
    </h2>
    <div>
      <div class="row">
        <div class="col-6">
          <app-mat-form-field>
            <input appMatInput type="text" formControlName="name" placeholder="Name" />
            <app-mat-error *ngIf="form && form?.get('name')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
        <div class="col-6">
          <app-mat-form-field>
            <app-mat-label>Source</app-mat-label>
            <app-mat-select formControlName="source">
              <app-mat-option *ngFor="let source of sources" [value]="source.type">
                {{ source.text }}
              </app-mat-option>
            </app-mat-select>
            <app-mat-error *ngIf="form && form?.get('source')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
        <div class="col-6">
          <app-mat-form-field>
            <input appMatInput type="number" formControlName="frequency" placeholder="Interval" />
            <app-mat-hint>Milliseconds.</app-mat-hint>
            <app-mat-error *ngIf="form && form?.get('frequency')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
        <div class="col-6">
          <app-mat-form-field>
            <app-mat-label>Trigger Type</app-mat-label>
            <app-mat-select formControlName="triggerType">
              <app-mat-option *ngFor="let option of trigerTypeEnum | enumToArray : 'string'" [value]="option.value">
                <span>{{ option.name | titlecase }}</span>
              </app-mat-option>
            </app-mat-select>
            <app-mat-error *ngIf="form && form?.get('triggerType')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>

        <div class="col-12 command-version" [hidden]="!isControlsVisible">
          <h3>Action</h3>
          <app-mat-radio-group formControlName="commandVersion" (change)="onSwitchcommandVersion($event)">
            <app-mat-radio-button class="mr-4" value="commands-v2">Command</app-mat-radio-button>
            <ng-container *ngIf="isControlsVisible">
              <app-mat-radio-button class="mr-4" value="controls">Control</app-mat-radio-button>
            </ng-container>
          </app-mat-radio-group>
        </div>

        <div *ngIf="commandVersion.value === 'controls'" class="col-12">
          <ng-container>
            <div class="control-warning-box">
              We recommend using a Command if possible, as Controls are deprecated. For more information contact
              <a href="mailto:support@rocos.io" appExternalLink>support&#64;rocos.io</a>
            </div>
          </ng-container>
        </div>

        <div class="col-6" *ngIf="isControlsVisible && commandVersion.value === 'controls'">
          <!-- Controls -->
          <app-mat-form-field>
            <app-mat-select placeholder="Select a Control" formControlName="commandId">
              <app-mat-option *ngFor="let control of controls" [value]="control.id">
                {{ control.id }}
              </app-mat-option>
            </app-mat-select>
            <app-mat-error *ngIf="commandId?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>

        <div class="col-6" *ngIf="commandVersion.value === 'commands-v2'">
          <!-- Command V2 -->
          <app-mat-form-field>
            <app-mat-select placeholder="Select a Command" formControlName="commandId">
              <app-mat-option *ngFor="let command of commandsV2" [value]="command.id">
                {{ command.id }}
              </app-mat-option>
            </app-mat-select>
            <app-mat-error *ngIf="commandId?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
      </div>
    </div>
    <div class="footer">
      <button app-mat-flat-button color="primary" (clicked)="onSubmit()">
        <span>Save</span>
      </button>
    </div>
  </form>
</div>
